import { render } from "./TaskCreate.vue?vue&type=template&id=831b45ae&scoped=true"
import script from "./TaskCreate.vue?vue&type=script&lang=js"
export * from "./TaskCreate.vue?vue&type=script&lang=js"

import "./TaskCreate.vue?vue&type=style&index=0&id=831b45ae&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831b45ae"]])

export default __exports__